const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;

const { InspectorControls } = wp.blockEditor;

const {
	PanelBody,
	SelectControl,
	Disabled,
	ToggleControl
} = wp.components;
const { serverSideRender: ServerSideRender } = wp;

import icons from "../../../icons.js";
/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
registerBlockType("wp-apidae/tourisme-affaire", {
	title: __("Tourisme d'affaire", "wp-apidae"), // Block title.
	description: __("Affiche les informations sur le tourisme d'affaire.", "wp-apidae"),
	icon: {
		foreground: '#EFB114',
		background: '#331F5B',
		src: icons.package
	},
	supports: {
    align: ['full','wide'],
  },
	example: {
  },
	attributes: {
		sallesEquipeesPour: {
			type: "boolean",
			default: true,
		},
		sallesEquipement: {
			type: "boolean",
			default: true,
		},
		sallesRestauration: {
			type: "boolean",
			default: true,
		},
		sallesHebergement: {
			type: "boolean",
			default: true,
		},
		sallesReunion: {
			type: "boolean",
			default: true,
		},
		show_title: {
			type: "boolean",
			default: true,
		},
		field_tag: {
			type: "string",
			default: "h2",
		},
		ss_field_tag: {
			type: "string",
			default: "h3",
		},
		align: {
			type: 'string',
			default: '',
		},
	},

	edit: class extends wp.element.Component {
		render() {
			const props = this.props;
			const attributes = props.attributes;

			var template = window.WpApidaeTemplateData.settings;
			const fieldsTags = window.WpApidaeTemplateData.fieldsTags;

			return [
				<InspectorControls key={"inspector"}>
					<PanelBody title={__("Affichage")}>
						<ToggleControl
							label={__("Salles équipées pour")}
							checked={attributes.sallesEquipeesPour}
							onChange={() => {
								props.setAttributes({
									sallesEquipeesPour: !attributes.sallesEquipeesPour,
								});
							}}
						/>
						<ToggleControl
							label={__("Equipement salles")}
							checked={attributes.sallesEquipement}
							onChange={() => {
								props.setAttributes({ services: !attributes.sallesEquipement });
							}}
						/>
						<ToggleControl
							label={__("Salles restauration")}
							checked={attributes.sallesRestauration}
							onChange={() => {
								props.setAttributes({
									sallesRestauration: !attributes.sallesRestauration,
								});
							}}
						/>
						<ToggleControl
							label={__("Salles hébergement")}
							checked={attributes.sallesHebergement}
							onChange={() => {
								props.setAttributes({
									sallesHebergement: !attributes.sallesHebergement,
								});
							}}
						/>
						<ToggleControl
							label={__("Salles réunions")}
							checked={attributes.sallesReunion}
							onChange={() => {
								props.setAttributes({
									sallesReunion: !attributes.sallesReunion,
								});
							}}
						/>
					</PanelBody>
					<PanelBody title={__("Options")}>
						<ToggleControl
							label={__("Afficher un titre de section")}
							checked={attributes.show_title}
							onChange={() => {
								props.setAttributes({ show_title: !attributes.show_title });
							}}
						/>
						{true === attributes.show_title && (
							<SelectControl
								label={__("Balise à utiliser")}
								value={attributes.field_tag}
								options={fieldsTags}
								onChange={(newValue) => {
									props.setAttributes({
										field_tag: newValue,
									});
								}}
							/>
						)}
						<SelectControl
							label={__("Balise des sous titres")}
							value={attributes.ss_field_tag}
							options={fieldsTags}
							onChange={(newValue) => {
								props.setAttributes({
									ss_field_tag: newValue,
								});
							}}
						/>
					</PanelBody>
				</InspectorControls>,
				<Disabled>
					<ServerSideRender
						block="wp-apidae/tourisme-affaire"
						attributes={attributes}
						urlQueryArgs={{
							settings: template,
						}}
					/>
				</Disabled>,
			];
		}
	},

	save: () => {
		return null;
	},
});
